// The tone of a free read's lines, from the server's data (#3573).
//
// Every read card painted the major note in the warning red, so "mechanical
// engineering is offered here (direct entry, per the school's catalog)" read
// as bad news. The tone now comes from what the server decided (the major's
// status, each driver's standing), never from the words of the line: red is
// for a real concern only.
//
// major_status (fit_doors.MAJOR_*): 'offered' | 'admits_separately' | 'unconfirmed'.
// driver_tones: parallel to drivers, 'concern' | 'positive' | 'neutral'.

const TONES = new Set(['concern', 'positive', 'neutral']);

// Text and marker colours per tone. Positive keeps the body colour (good news
// is said plainly, not shouted); only a concern changes the line's colour.
export const TONE_STYLE = {
    concern: { text: 'text-[#C05838]', marker: 'text-[#C05838]' },
    positive: { text: 'text-[#4A4A4A]', marker: 'text-[#1A4D2E]' },
    neutral: { text: 'text-[#4A4A4A]', marker: 'text-[#1A4D2E]' },
};

/** The major note's tone. A read stored before #3573 has no status; its
 *  `major_impacted` flag (the precompute's) still marks a real concern, and
 *  with neither the note stays neutral rather than guessing red. */
export function majorNoteTone(read) {
    const status = read?.major_status;
    if (status === 'admits_separately') return 'concern';
    if (status === 'offered') return 'positive';
    if (status === 'unconfirmed') return 'neutral';
    return read?.major_impacted === true ? 'concern' : 'neutral';
}

/** One tone per driver. Tones that don't line up with the drivers are
 *  dropped whole, so a tone can never land on the wrong line. */
export function driverTones(read) {
    const drivers = Array.isArray(read?.drivers) ? read.drivers : [];
    const tones = read?.driver_tones;
    if (!Array.isArray(tones) || tones.length !== drivers.length) {
        return drivers.map(() => 'neutral');
    }
    return tones.map((t) => (TONES.has(t) ? t : 'neutral'));
}
